import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import config from "./config";

const SEO = ({
  title,
  description,
  image = "/assets/images/logo/og-uniart-img.png",
}: {
  title?: string;
  description?: string;
  image?: string;
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const baseURL = "https://uniart.ro";
  //const currentLang = i18n.language || "ro"; // Alapértelmezett: román
  const pageTitle = title || t("siteTitle");
  const pageDescription = description || t("siteDescription");
  const pageKeywords = t("metaKeywords");
  const pageURL = `${baseURL}${location.pathname}`;

  // Hreflang tagek a keresőmotorok számára
  // const languages = ["ro", "en", "hu"];
  // const hreflangTags = languages.map((lng) => (
  //   <link
  //     key={lng}
  //     rel="alternate"
  //     href={`${baseURL}/${lng}${location.pathname}`}
  //     hrefLang={lng}
  //   />
  // ));

  return (
    <Helmet>
      {/* Alap SEO meta tagek */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="UNIART" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={pageURL} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${baseURL}${image}`} />

      {/* Twitter Card meta tagek */}
      <meta property="twitter:image" content={`${baseURL}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />

      <link rel="canonical" href={pageURL} />

      {/* JSON-LD Strukturált Adatok */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "UNIART",
          url: baseURL,
          logo: `${baseURL}/assets/images/logo/og-uniart-img.png`,
          description: pageDescription,
          foundingDate: "1992",
          founder: {
            "@type": "Person",
            name: "UNIART Team",
          },
          address: {
            "@type": "PostalAddress",
            streetAddress: "str. Gării nr. 460",
            addressLocality: "com. Călărași, jud. Cluj",
            addressCountry: "RO",
          },
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+40 722 762 291",
            email: "info@uniart.ro",
            contactType: "customer service",
          },
          sameAs: [config.facebookPage],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
